// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@charset \"UTF-8\";\n.timeline-box[data-v-7dceb323] {\n  overflow-y: auto;\n  -ms-overflow-style: none; /* 针对 IE 和 Edge 隐藏滚动条 */\n  scrollbar-width: none; /* 针对 Firefox 隐藏滚动条 */\n}\n.timeline-box[data-v-7dceb323]::-webkit-scrollbar {\n  display: none; /* 针对 Webkit 内核浏览器隐藏滚动条 */\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
